import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';

// custom form input used for making dynamically forms

// TODO: To refactor the styles using modules.css - developer: Edied Isaías Ramos Hernández

export const InputFormControl = ({
  name,
  control,
  type,
  defaultValue = '',
  rules = {},
  placeholder,
  error,
  customHeight = null,
  border = null,
  customStyles = null,
  className = ''
}) => {
  const style = {
    inputLabel: {
      fontSize: '1rem'
    },
    input: {
      width: '100%',
      padding: '5px 10px',
      backgroundColor: 'transparent',
      border: 'none',
      borderBottom: '1px solid #ddd'
    },
    inputError: {
      backgroundColor: 'rgb(255, 233, 233)'
    },
    alert_danger: {
      color: '#721c24',
      backgroundColor: '#f8d7da',
      borderColor: '#f5c6cb'
    },
    alert_success: {
      color: '#155724',
      backgroundColor: '#d4edda',
      borderColor: '#c3e6cb'
    },
    bg: {
      backgroundColor: '#ada'
    }
  };
  return (
    <>
      <Controller
        className={className}
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={(props) => (
          <Form.Control
            {...props}
            type={type}
            placeholder={placeholder}
            isInvalid={!!error}
            className={className}
            style={
              !error ? { ...style.input, ...customStyles } : { ...style.input, ...style.inputError }
            }
          />
        )}
      />
      {error && <Form.Control.Feedback type="invalid">{error?.message}</Form.Control.Feedback>}
    </>
  );
};
